module.exports = { environment: 'prod' }
